import {useQuery} from "@tanstack/react-query";
import {
    fetchAppSheetOptionsForClient,
    fetchAppSheetOptionsForProjectPosition,
    fetchAppSheetOptionsForProject,
    fetchForTalentAsManager,
    fetchTalentUserStatsForTalentManager
} from "../requests/ClientLeadRequests"
import {
    fetchAllSupplierOpportunities,
    fetchAllSupplierTalentResources,
    fetchOpportunityForAgency,
    fetchSupplierDashboard,
    fetchSupplierTalentResource,
    fetchTalentResourcesForJobBoard
} from "../requests/SupplierRequests";
import {
    fetchRecipientUsers,
    fetchSharableForPosition, fetchTalentCandidateScope,
    positionMatches,
    getPositionMatchingTalentCount,
    searchCandidates, searchDeliverablesByDisciplines, searchPositionTemplateTags
} from "../requests/BYORequests";
import {
    fetchClientProjectGroups,
    fetchClientUsers,
    fetchProject,
    fetchTalentPools,
    fetchTalentPoolDetail,
    searchProjectKeywords,
    searchForTalent,
    fetchGreenlightOptionsForCandidate,
    searchTalentSkills,
    searchTalentBrands,
    searchForTeams
} from "../requests/ClientRequests";
import {
    fetchAllServices,
    fetchProjectTemplate,
    fetchServicesByCategory,
    fetchTeamCandidateScope,
    fetchTemplatesFromTags,
    searchProjectTemplateTags,
    teamMatches
} from "../requests/ServiceProjectRequests";
import {
    fetchAllTeamsForTalent,
    fetchJobBoardDetails,
    fetchJobBoardForTalent,
    fetchCoverLettersForTalent,
    fetchOpportunityForTalent,
    searchAllTalentForMemberInvite,
    searchBrands, fetchLatestVideoInterviewForTalent, searchTagsExpertise
} from "../requests/TalentUserRequests";
import {
    fetchClient,
    fetchMeetings,
    fetchTalent,
    fetchTalentTeam,
    fetchTalentReviews,
    fetchTeam,
    markProposalAsViewed
} from "../requests/SharedRequests";
import QueryOptions from "./QueryOptions";
import {useMemo} from "react";
import {useMount} from "react-use";

const requests = {
    // ClientLead
    'fetchAppSheetOptionsForClient': fetchAppSheetOptionsForClient,
    'fetchAppSheetOptionsForProjectPosition': fetchAppSheetOptionsForProjectPosition,
    'fetchAppSheetOptionsForProject': fetchAppSheetOptionsForProject,
    'fetchForTalentAsManager': fetchForTalentAsManager,
    'fetchTalentUserStatsForTalentManager': fetchTalentUserStatsForTalentManager,
    // Supplier/Agency
    'fetchSupplierDashboard': fetchSupplierDashboard,
    'fetchAllSupplierOpportunities': fetchAllSupplierOpportunities,
    'fetchSupplierTalentResource': fetchSupplierTalentResource,
    'fetchAllSupplierTalentResources': fetchAllSupplierTalentResources,
    'fetchTalentResourcesForJobBoard': fetchTalentResourcesForJobBoard,
    'fetchOpportunityForAgency': fetchOpportunityForAgency,

    // Client - Project
    'fetchClientProjectGroups': fetchClientProjectGroups,
    'fetchClientUsers': fetchClientUsers,
    'fetchProject': fetchProject,
    'searchProjectKeywords': searchProjectKeywords,
    'searchForTalent': searchForTalent,
    'searchForTeams': searchForTeams,
    'fetchGreenlightOptionsForCandidate': fetchGreenlightOptionsForCandidate,
    'searchTalentSkills': searchTalentSkills,
    'searchTalentBrands': searchTalentBrands,

    // Client - Service/Teams
    'fetchAllServices': fetchAllServices,
    'fetchServicesByCategory': fetchServicesByCategory,
    'teamMatches': teamMatches,
    'fetchTeamCandidateScope': fetchTeamCandidateScope,
    'fetchTemplatesFromTags': fetchTemplatesFromTags,
    'searchProjectTemplateTags': searchProjectTemplateTags,
    'fetchProjectTemplate': fetchProjectTemplate,

    // Client - BYO/ProjectPosition
    'positionMatches': positionMatches,
    'getPositionMatchingTalentCount': getPositionMatchingTalentCount,
    'fetchSharableForPosition': fetchSharableForPosition,
    'searchDeliverablesByDisciplines': searchDeliverablesByDisciplines,
    'fetchTalentCandidateScope': fetchTalentCandidateScope,
    'searchCandidates': searchCandidates,
    'fetchRecipientUsers': fetchRecipientUsers,
    'searchPositionTemplateTags': searchPositionTemplateTags,

    // Talent
    'fetchOpportunityForTalent': fetchOpportunityForTalent,
    'fetchCoverLettersForTalent': fetchCoverLettersForTalent,
    'fetchJobBoardForTalent': fetchJobBoardForTalent,
    'fetchJobBoardDetails': fetchJobBoardDetails,
    'fetchAllTeamsForTalent': fetchAllTeamsForTalent,
    'fetchLatestVideoInterviewForTalent': fetchLatestVideoInterviewForTalent,
    'searchTagsExpertise': searchTagsExpertise,
    'searchAllTalentForMemberInvite': searchAllTalentForMemberInvite,
    'searchBrands': searchBrands,

    // SHARED
    'fetchMeetings': fetchMeetings,
    'markProposalAsViewed': markProposalAsViewed,
    'fetchClient': fetchClient,
    'fetchTeam': fetchTeam,
    'fetchTalentTeam': fetchTalentTeam,
    'fetchTalent': fetchTalent,
    'fetchTalentPools': fetchTalentPools,
    'fetchTalentPoolDetail': fetchTalentPoolDetail,
    'fetchTalentReviews': fetchTalentReviews,
}

const useAPI = (key= [] || '', queryOptions = {}) => {

    const queryKey = TB.isString(key) ? [key] : key;
    const lookup = queryKey[0]
    const request = requests[lookup]

    const options = useMemo(() => {
        let handlers = {
            onError: async (error) => {
                console.error(`on${TB.upperFirst(lookup)}Error`, error);
            },
            onSuccess: async (data) => {
                console.log(`on${TB.upperFirst(lookup)}Success`, data);
            },
        };
        if (QueryOptions[lookup]) {
            handlers = {
                ...handlers,
                ...QueryOptions[lookup]
            }
        }
        return {
            ...handlers,
        }
    }, [lookup]);

    useMount(() => {
        if (!request) {
            console.error(`Request not found`, queryKey)
        }
    })
    if (!request) {
        return {}
    }
    return useQuery(
        queryKey,
        request,
        {...options, ...queryOptions}
    )
}

export {
    useAPI
};